export const ROUTES = {
  DASHBOARD: '/',
  //Staking
  STAKING: '/staking',
  STAKING_TOKEN: '/staking-token',
  STAKING_DETAIL: '/staking-detail',
  //Staking
  STAKING_NFT: '/staking-nft',
  STAKING_ERC3643: '/staking-erc-3643',
  //P2P Lending
  P2P_LENDING: '/p2plending',
  P2P_DETAIL: '/p2p-detail',
  // pto
  PTO: '/pto',
  PTO_V2: '/pto-v2',
  PTO_V3: '/pto-v3',
  PTO_DETAIL: '/pto-detail',
  PTO_REWARDS: '/pto-rewards',
  PTO_REFERRAL: '/pto-referral',
  BOOSTER_PROGRAM: '/booster-program',
  PROPERTY_ACTIVITIES: '/property-activities',
  // promo code
  PROMO_CODE: '/promo-code',
  //affiliates
  AFFILIATES: '/affiliates',
  AFFILIATES_TREE: '/affiliates-tree',
  //vesting
  VESTING: '/vesting',
  VESTING_HMC: '/hmc-vesting',
  VESTING_VENTURE: '/venture-vesting',
  VESTING_HMC_V2: '/hmc-vesting-v2',
  VESTING_VENTURE_V2: '/venture-vesting-v2',
  ACCOUNT_VESTING_HMC: '/account-vesting-hmc',
  ACCOUNT_VESTING_VENTURE: '/account-vesting-venture',
  ACCOUNT_VESTING_HMC_V2: '/account-vesting-hmc-v2',
  ACCOUNT_VESTING_VENTURE_V2: '/account-vesting-venture-v2',
  //user
  USER: '/user',
  USER_MEY_REAL: '/user-mey-real',
  TRANSACTION_HISTORY: '/transaction-history',
  USER_ADMIN: '/admin',
  UPDATE_PASSWORD: '/update-password',
  EMAIL: '/email',
  EMAIL_V2: '/email-v2',
  // airdrop
  AIRDROP: '/airdrop',
  // marketplace
  MARKETPLACE: '/marketplace',
  PORTAL: '/portal',
  //other
  LOGIN: '/login',
  SETTING: '/setting',
  STAKING_TOKEN_CONFIG: '/staking-token-config',
  NO_PERMISSION: '/no-permission',
  // banner
  BANNER: '/banner',
  // dao
  DAO_VOTING: '/dao-voting',
  // whats new
  WHATS_NEW: '/whats-new',
  FAQ: '/faq',
}

export const PAGES = {
  ...ROUTES,
  //Staking
  STAKING_DETAIL: `${ROUTES.STAKING_DETAIL}/:contract`,
  //Staking Nft
  STAKING_ERC3643_POOL_DETAIL: `${ROUTES.STAKING_ERC3643}/pools/:poolId`,
  STAKING_NFT_PTO: `${ROUTES.STAKING_NFT}/:id${ROUTES.PTO}`,
  STAKING_NFT_TRANSACTION: `${ROUTES.STAKING_NFT}/:id${ROUTES.PTO}/:ptoId`,
  // Staking Token
  STAKING_TOKEN_DETAIL: `${ROUTES.STAKING_TOKEN}/:id`,
  //P2P Lendingr
  P2P_LENDING_CREATE: `${ROUTES.P2P_LENDING}/create`,
  P2P_LENDING_DETAIL: `${ROUTES.P2P_LENDING}/:code`,
  // pto
  PTO_DETAIL_CODE: `${ROUTES.PTO}/:code`,
  PTO_CREATE: `${ROUTES.PTO}/create`,
  PTO_V2_DETAIL_CODE: `${ROUTES.PTO_V2}/:code`,
  PTO_V2_CREATE: `${ROUTES.PTO_V2}/create`,
  PTO_V3_DETAIL_CODE: `${ROUTES.PTO_V3}/:code`,
  PTO_V3_CREATE: `${ROUTES.PTO_V3}/create`,
  PROPERTY_ACTIVITIES_DETAIL: `${ROUTES.PROPERTY_ACTIVITIES}/:ptoId`,
  // booster program
  BOOSTER_PROGRAM_DETAIL: `${ROUTES.BOOSTER_PROGRAM}/:id`,
  BOOSTER_PROGRAM_CREATE: `${ROUTES.BOOSTER_PROGRAM}/create`,

  //affiliates
  AFFILIATES_TREE_ADDRESS: `${ROUTES.AFFILIATES_TREE}/:address`,
  // airdrop
  AIRDROP_CREATE: `${ROUTES.AIRDROP}/create`,
  AIRDROP_DETAIL: `${ROUTES.AIRDROP}/:code`,
  // marketplace
  MARKETPLACE_CREATE: `${ROUTES.MARKETPLACE}/create`,
  MARKETPLACE_DETAIL: `${ROUTES.MARKETPLACE}/:code`,
  // dao voting
  DAO_VOTING_DETAIL: `${ROUTES.DAO_VOTING}/:id`,
  // faq
  FAQ_ARTICLE_CREATE: `${ROUTES.FAQ}/articles/create`,
  FAQ_ARTICLE_DETAIL: `${ROUTES.FAQ}/articles/:id`,
  FAQ_ARTICLE_EDIT: `${ROUTES.FAQ}/articles/:id/edit`,
}
